import styled from 'styled-components/macro';

import { sizes, shadows } from '../../styles/vars';

const AddListWrapper = styled.div`
  position: absolute;
  top: -1px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${sizes.pageWidth};
  min-width: ${sizes.pageMinWidth};
  height: 90px;
  padding-top: 1px;
  background-color: #3d3234;
  box-shadow: ${shadows.list};
  overflow: hidden;
`;

export default AddListWrapper;
